import { createBrowserRouter } from 'react-router'
import App from '@/App'
import RouteErrorBoundary from '@/shared/components/RouteErrorBoundary'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        lazy: async () => {
          const { HomePage } = await import('@/features/home/pages/HomePage')
          return { Component: HomePage }
        },
      },
      {
        path: 'signup',
        lazy: async () => {
          const [{ SignupPage }, { signupLoader }] = await Promise.all([
            import('@/features/auth/pages/SignupPage'),
            import('@/features/auth/pages/signupLoader'),
          ])
          return { Component: SignupPage, loader: signupLoader }
        },
      },
      {
        path: 'giftcards',
        lazy: async () => {
          const { GiftCardsPage } = await import('@/features/giftcards/pages/GiftCardsPage')
          return { Component: GiftCardsPage }
        },
      },
      {
        path: 'giftcards/:id',
        lazy: async () => {
          const { GiftCardDetailPage } =
            await import('@/features/giftcards/pages/GiftCardDetailPage')
          return { Component: GiftCardDetailPage }
        },
      },
      {
        path: 'checkout',
        lazy: async () => {
          const { CheckoutPage } = await import('@/features/giftcards/pages/CheckoutPage')
          return { Component: CheckoutPage }
        },
      },
      {
        path: 'orders/:uuid',
        lazy: async () => {
          const { OrderPage } = await import('@/features/giftcards/pages/OrderPage')
          return { Component: OrderPage }
        },
      },
      {
        path: 'orders',
        lazy: async () => {
          const { OrdersPage } = await import('@/features/giftcards/pages/OrdersPage')
          return { Component: OrdersPage }
        },
      },
      {
        path: 'payment/:uuid',
        lazy: async () => {
          const { PaymentPage } = await import('@/features/giftcards/pages/PaymentPage')
          return { Component: PaymentPage }
        },
      },
      {
        path: 'redeem',
        lazy: async () => {
          const { RedeemPage } = await import('@/features/redeem/pages/RedeemPage')
          return { Component: RedeemPage }
        },
      },
      {
        path: 'profile',
        lazy: async () => {
          const { ProfilePage } = await import('@/features/profile/pages/ProfilePage')
          return { Component: ProfilePage }
        },
      },
      {
        path: 'profile/access-tokens',
        lazy: async () => {
          const { AccessTokensPage } = await import('@/features/profile/pages/AccessTokensPage')
          return { Component: AccessTokensPage }
        },
      },
      {
        path: 'profile/change-password',
        lazy: async () => {
          const { ChangePasswordPage } = await import('@/features/auth/pages/ChangePasswordPage')
          return { Component: ChangePasswordPage }
        },
      },
      {
        path: 'profile/about',
        lazy: async () => {
          const { AboutPage } = await import('@/features/profile/pages/AboutPage')
          return { Component: AboutPage }
        },
      },
      {
        path: 'profile/referrals',
        lazy: async () => {
          const { ReferralsPage } = await import('@/features/profile/pages/ReferralsPage')
          return { Component: ReferralsPage }
        },
      },
      {
        path: 'profile/settings',
        lazy: async () => {
          const { ProfileSettingsPage } =
            await import('@/features/profile/pages/ProfileSettingsPage')
          return { Component: ProfileSettingsPage }
        },
      },
      {
        path: 'profile/balances',
        lazy: async () => {
          const { BalancesPage } = await import('@/features/balances/pages/BalancesPage')
          return { Component: BalancesPage }
        },
      },

      {
        path: '*',
        element: <div className="p-8 text-center">Page not found</div>,
      },
    ],
  },
])
